import { GuidelinesNotSavedChangesEntity } from './guidelines-not-saved-changes.reducer';
import { createAction, props } from '@ngrx/store';

export const updateNotSavedPartPricingState = createAction(
  'Update Not Saved Part Pricing State',
  props<GuidelinesNotSavedChangesEntity>()
);

export const removeAllNotSavedChanges = createAction('Remove All Not Saved Guidelines Changes');

export const removeNotSavedChangesByCountryId = createAction(
  'Remove All Not Saved Guidelines Changes by countryId',
  props<{ countryId: string }>()
);
